var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.waitingWorker)?_c('div',{staticClass:"notification is-warning update-prompt"},[_c('span',[_vm._v("Достапна е нова верзија.")]),_c('button',{staticClass:"button is-small is-dark",class:{'is-loading': _vm.updating},on:{"click":_vm.applyUpdate}},[_vm._v("Освежи")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }